import { QueryPageParams } from "../../redux/RTKQuery/api";

export interface Transaction {
    id: number;
    orderId: string;
    transactionId: string;
    amount: number;
    currency: string;
    status: TransactionStatus;
    productTitle: string;
    createdAt: string;
    updatedAt: string;
}

export enum TransactionStatus {
    Pending = 0,
    Completed = 1,
    Failed = 2,
    Refunded = 3,
}

export interface FetchTransactions {
    totalCount: number;
    filteredCount: number;
    items: Transaction[];
}

export interface TransactionsQueryParams extends Partial<QueryPageParams> {
    orderId?: string;
    transactionId?: string;
    productId?: number;
    status?: TransactionStatus;
    startDate?: number;
    endDate?: number;
}

export type TransactionRow = Pick<
    Transaction,
    | "id"
    | "orderId"
    | "transactionId"
    | "amount"
    | "currency"
    | "status"
    | "productTitle"
    | "createdAt"
>;
